export default "__VITE_ASSET__DeNmg0Bs__"